import { useSelector } from "react-redux";
import Icons from "../assets/icon/index";

const useUserDashboardStatusData = () => {
  const user = useSelector((state) => state.app.userData.userData);
  return [
    {
      id: 2,
      title: "Favourites",
      icon: Icons.favouritesIcon,
      notification: "",
      layout: "#D3235F",
      iconLayout: "w-8/12",
      to: "/favourites",
      textsize:
        "xs:!text-[8px] sm:text-xs lg:text-sm 3xl:text-base font-onestMedium",
      postion:
        "right-0 xs:-top-2 -top-3 rounded-full xs:w-4 xs:h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 3xl:w-7 3xl:h-7",
    },
    {
      id: 4,
      title: user?.role === "employer" ? "Hire Request" : "Hiring Request",
      icon: Icons.HiringRequestIcon,
      notification: "",
      layout: "#FC7336",
      iconLayout: "w-8/12",
      to:
        user?.role === "employer"
          ? "/employer-hire-request"
          : user?.role === "fan"
          ? "/upgrade"
          : "/hiring-requests",
      textsize:
        "xs:!text-[8px] sm:text-xs lg:text-sm 3xl:text-base font-onestMedium",
      postion:
        "right-0 xs:-top-2 -top-3 rounded-full xs:w-4 xs:h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 3xl:w-7 3xl:h-7",
    },
    {
      id: 5,
      title: user?.role === "employer" ? "Post Jobs" : "Jobs Applied",
      icon: Icons.JobsAppliedIcon,
      notification: "",
      layout: "#23B5D3",
      iconLayout: "w-8/12",
      to:
        user?.role === "employer"
          ? "/empjob-listing"
          : user?.role === "fan"
          ? "/upgrade"
          : "/applied-jobs",
      textsize:
        "xs:!text-[8px] sm:text-xs lg:text-sm 3xl:text-base font-onestMedium",
      postion:
        "right-0 xs:-top-2 -top-3 rounded-full xs:w-4 xs:h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 3xl:w-7 3xl:h-7",
    },
    {
      id: 6,
      title: "Total Referrals",
      icon: Icons.totalReferralsIcon,
      notification: "",
      layout: "#3DFC36",
      iconLayout: "w-8/12",
      // textsize: 'xs:!text-[8px] sm:text-[12px] lg:text-sm 3xl:text-base font-onestMedium',
      // postion: 'right-0 xs:-top-2 -top-3 xs:w-20 xs:h-5 sm:w-28 sm:h-6 lg:w-28 lg:h-7 3xl:w-36 3xl:h-8',
    },
    {
      id: 1,
      title: "Member Perks",
      icon: Icons.memberPerksIcon,
      notification: "Coming Soon",
      layout: "#37D16F",
      iconLayout: "w-8/12",
      textsize:
        "xs:!text-[8px] sm:text-[12px] lg:text-sm 3xl:text-base font-onestMedium",
      postion:
        "right-0 xs:-top-2 -top-3 xs:!rounded-[4px] sm:rounded-md xs:w-20 xs:h-5 sm:w-28 sm:h-6 lg:w-28 lg:h-7 3xl:w-36 3xl:h-8",
    },
    {
      id: 3,
      title: "Reward Points",
      icon: Icons.rewardPointsIcon,
      notification: "Coming Soon",
      layout: "#D750FF",
      iconLayout: "w-8/12",
      textsize:
        "xs:!text-[8px] sm:text-[12px] lg:text-sm 3xl:text-base font-onestMedium",
      postion:
        "right-0 xs:-top-2 -top-3 xs:!rounded-[4px] sm:rounded-md xs:w-20 xs:h-5 sm:w-28 sm:h-6 lg:w-28 lg:h-7 3xl:w-36 3xl:h-8",
    },
  ];
};

export default useUserDashboardStatusData;
